export enum RCustomerLookupEntityType {
  Customer = 'customer',
  Receiver = 'receiver'
}
